export class EquipmentType {
  id: number;
  name: string;
  checklistId: number;
  catId: number;
  code: string;

  public static constructFromObjectJson(objectJson: any): EquipmentType {
    const equipmentType: EquipmentType = Object.assign(new EquipmentType(), objectJson);
    return equipmentType;
  }

  public static constructFromMapEntry(mapEntry: any): EquipmentType {
    const equipmentType: EquipmentType = new EquipmentType();
    equipmentType.id = mapEntry[0];
    equipmentType.name = mapEntry[1];
    return equipmentType;
  }

  public static constructEquipmentType(typeId: number, name: string): EquipmentType {
    const equipmentType: EquipmentType = new EquipmentType();
    equipmentType.id = typeId;
    equipmentType.name = name;
    return equipmentType;
  }
}
